import React from 'react'
import { isValidCoord, } from '../../util/mapCalcs'
import { arrayIsNullOrEmpty, mapAddressTypeNameToCategory, } from '../../util/helpers'
import PropTypes from 'prop-types'
import ProgramMapMarker from './ProgramMapMarker'	
import DetailMapMarker from './DetailMapMarker'

const noop = () => {}
const ProgramAddressCollection = ({
  locations = [],
  typeFilters = [ 'worksite', 'contact', 'institution', 'partner', 'how_to_apply', 'session', ],
  programName = '',
  programOccupation = '',
  programType = '',
  userLocation = null,
  activeIndex = null,
  setActiveIndex = noop,
}) => {
  const resetActiveIndex = React.useCallback(() => {
    setActiveIndex(null)
  }, [ setActiveIndex, ])

  const setActiveMarkerIndex = React.useCallback((idx) => {
    setActiveIndex(idx)
  }, [ setActiveIndex, ])
  
  const otherMarkers = []
  if (userLocation) {
    otherMarkers.push(
      <ProgramMapMarker 
        key={'loc-user'} 
        lat={userLocation.coords.latitude} 
        lng={userLocation.coords.longitude} 
        type={''}
        programType={'location'}
        name={'Your Location'}
        viewUrl={''}
        title={''}
        desc={''}
        address={''}
      />)
  }

  let markers = []
  if (!arrayIsNullOrEmpty(locations)) {
    markers = locations.reduce((acc, curr, idx) => {
      const locationType = mapAddressTypeNameToCategory(curr.type)
      if (!curr || !curr.lat || !curr.lon || !typeFilters.includes(locationType)) {
        return acc
      }
      if (!isValidCoord(curr.lat, curr.lon)) {
        console.warn('invalid coordinate provided: ', curr.lat, curr.lon)
        return acc
      }
      acc.push(<DetailMapMarker 
        key={`loc-${idx}`} 
        lat={curr.lat} 
        lng={curr.lon} 
        type={curr.type}
        name={curr.name}
        programType={programType}
        title={programOccupation}
        desc={programName}
        address={curr.address}
        active={activeIndex === curr.index}
        setActiveIndex={() => setActiveMarkerIndex(curr.index)}
        resetActiveIndex={() => resetActiveIndex(null)}
      />)
      return acc
    }, [])
  }
  return otherMarkers.concat(markers)
}

ProgramAddressCollection.propTypes = {
  locations         : PropTypes.array,
  typeFilters       : PropTypes.arrayOf(PropTypes.string),
  programName       : PropTypes.string,
  programOccupation : PropTypes.string,
  programType       : PropTypes.string,
  activeIndex       : PropTypes.oneOfType([ PropTypes.number, PropTypes.string, ]),
  setActiveIndex    : PropTypes.func,
}

export default ProgramAddressCollection
